import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import {
  ensureFeatureSwitchesLoaded,
  useFeatureSwitchState,
} from './featureSwitchSession';

/**
 * A typed URL whose switch is off redirects. While GET /features is in
 * flight the surface is not rendered, so a switched feature never flashes.
 */
export function FeatureRoute({
  feature,
  redirectTo,
  children,
}: {
  feature: string;
  redirectTo: string;
  children: ReactNode;
}) {
  useEffect(() => {
    ensureFeatureSwitchesLoaded();
  }, []);
  const state = useFeatureSwitchState(feature);
  if (state === 'pending') return null;
  if (state === 'off') return <Navigate to={redirectTo} replace />;
  return children;
}
